(function () {
  const carences = {
    fer: {
      label: "Fer",
      texte: "Fatigue, pâleur, essoufflement ou ongles fragiles peuvent évoquer une piste liée au fer.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/shilajit-soutien-mineral-contre-la-carence-en-fer"
    },
    magnesium: {
      label: "Magnésium",
      texte: "Crampes, fatigue nerveuse ou concentration difficile peuvent évoquer une piste liée au magnésium.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/carence-en-magnesium-le-role-cle-du-shilajit"
    },
    b12: {
      label: "Vitamine B12",
      texte: "Fatigue, fourmillements ou difficultés de concentration peuvent évoquer une piste liée à la vitamine B12.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/carences-en-mineraux-secondaires-signes-causes-et-solutions-naturelles"
    },
    vitamineD: {
      label: "Vitamine D",
      texte: "Baisse de tonus, moral bas ou fragilité immunitaire peuvent évoquer une piste liée à la vitamine D.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/carence-en-vitamine-d-symptomes-causes-et-solutions-naturelles"
    },
    zinc: {
      label: "Zinc",
      texte: "Chute de cheveux, ongles fragiles, cicatrisation lente ou immunité fragile peuvent évoquer une piste liée au zinc.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/shilajit-et-zinc-solution-naturelle-contre-la-fatigue"
    },
    potassium: {
      label: "Potassium",
      texte: "Crampes, faiblesse musculaire ou fatigue physique peuvent évoquer une piste liée au potassium.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/shilajit-et-potassium-un-soutien-naturel-efficace"
    },
    iode: {
      label: "Iode",
      texte: "Sensibilité au froid, fatigue ou métabolisme ralenti peuvent évoquer une piste liée à l’iode.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/metabolisme-ralenti-role-cle-de-l-iode-alimentaire"
    },
    selenium: {
      label: "Sélénium",
      texte: "Immunité fragile, fatigue ou équilibre thyroïdien peuvent évoquer une piste liée au sélénium.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/immunit-et-thyroide-l-importance-du-selenium"
    },
    calcium: {
      label: "Calcium",
      texte: "Fragilité osseuse, crampes ou ongles fragiles peuvent évoquer une piste liée au calcium.",
      url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/calcium-et-shilajit-une-solution-naturelle"
    }
  };

  function initBilanCarences() {
    const bilans = document.querySelectorAll(".psh-carence-bilan");

    if (!bilans.length) return;

    bilans.forEach(function (bilan) {
      if (bilan.dataset.initialized === "true") return;
      bilan.dataset.initialized = "true";

      const btn = bilan.querySelector(".psh-bilan-btn");
      const resultats = bilan.querySelector(".psh-bilan-resultats");

      if (!btn || !resultats) return;

      btn.addEventListener("click", function () {
        const scores = {};

        Object.keys(carences).forEach(function (key) {
          scores[key] = 0;
        });

        const checkedInputs = bilan.querySelectorAll("input[type='checkbox']:checked");

        checkedInputs.forEach(function (input) {
          const list = input.getAttribute("data-carences");
          if (!list) return;

          list.split(",").forEach(function (carence) {
            carence = carence.trim();

            if (scores[carence] !== undefined) {
              scores[carence]++;
            }
          });
        });

        const top = Object.entries(scores)
          .filter(function (entry) {
            return entry[1] > 0;
          })
          .sort(function (a, b) {
            return b[1] - a[1];
          })
          .slice(0, 3);

        if (!top.length) {
          resultats.innerHTML = "<p>Veuillez cocher au moins un signe pour afficher vos résultats.</p>";
          return;
        }

        let html = "<h3>Vos signes évoquent principalement :</h3>";

        top.forEach(function (entry) {
          const key = entry[0];
          const item = carences[key];

          html += `
            <div class="psh-result-card">
              <h3>${item.label}</h3>
              <p>${item.texte}</p>
              <a href="${item.url}">Lire l’article dédié</a>
            </div>
          `;
        });

        resultats.innerHTML = html;

        const yOffset = -120;
        const y = resultats.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBilanCarences);
  } else {
    initBilanCarences();
  }
})();